import EtablissementSelect from '@/generated/controls/etablissement/EtablissementSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementSelect
})